import React from 'react';
import { Group, Table, Text } from '@mantine/core';
import { HiOutlineSortAscending, HiOutlineSortDescending } from 'react-icons/hi';
import { DataTableHeadProps } from '.';
import { IconArrowsSort } from '@tabler/icons-react';
const THead: React.FC<DataTableHeadProps> = ({
  columns,
  data,
  isNumbering,
  sortConfig,
  onSort
}) => {
  return (
    <Table.Thead
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 2,
        backgroundColor: 'var(--mantine-color-body)'
      }}
    >
      <Table.Tr>
        {isNumbering && (
          <Table.Th c={'secondary.4'}>
            <Text fw={700} fz={12}>
              No.
            </Text>
          </Table.Th>
        )}
        {columns.map((column, index) => {
          if (!column.active) return null;
          return (
            <Table.Th key={index}>
              {column.sortable ? (
                <Group
                  c={'secondary.4'}
                  gap={4}
                  w={column.width}
                  style={{ cursor: 'pointer' }}
                  onClick={() => (data.length && onSort ? onSort(column) : null)}
                >
                  {typeof column.heading === 'string' ? (
                    <Text fw={700} fz={12}>
                      {column.heading}
                    </Text>
                  ) : (
                    column.heading
                  )}
                  {(!sortConfig.key ||
                    sortConfig.key !==
                      (typeof column.props === 'function' ? column.id : column.props)) && (
                    <IconArrowsSort size={16} />
                  )}
                  {sortConfig.key ===
                    (typeof column.props === 'function' ? column.id : column.props) &&
                    sortConfig.direction === 'asc' && <HiOutlineSortAscending size={16} />}
                  {sortConfig.key ===
                    (typeof column.props === 'function' ? column.id : column.props) &&
                    sortConfig.direction === 'desc' && <HiOutlineSortDescending size={16} />}
                </Group>
              ) : typeof column.heading === 'string' ? (
                <Text c={'secondary.4'} fw={700} fz={12}>
                  {column.heading}
                </Text>
              ) : (
                column.heading
              )}
            </Table.Th>
          );
        })}
      </Table.Tr>
    </Table.Thead>
  );
};

export default THead;
